/*
  Lista de deseos.

  Guardar favoritos exige sesión iniciada: el metacampo `custom.wishlist` es
  del cliente, y sin cliente no hay dónde guardar. Por eso al pulsar el
  corazón sin sesión no se guarda nada en el navegador — se abre el aviso de
  la sección «Favoritos: aviso sesión».

  El estado de quien sí ha iniciado sesión lo pinta Liquid desde el metacampo;
  aquí solo se alterna contra el App Proxy `/apps/divain/wishlist`.
*/
(() => {
  const cfg = window.divainWishlist || {};
  const RUTA = cfg.ruta || '/apps/divain/wishlist';
  const SEL = '[data-wishlist-product]';

  const identificado = cfg.identificado === true;

  // Mapa gid → handle. El handle viaja siempre: la página de favoritos lo
  // necesita para resolver el producto, porque Liquid no sabe buscar por ID.
  const aMapa = (items) => {
    const m = new Map();
    (items || []).forEach((i) => {
      if (i && i.id) m.set(i.id, i.handle || '');
    });
    return m;
  };

  let guardados = aMapa(cfg.items);

  const comoLista = () => Array.from(guardados, ([id, handle]) => ({ id, handle }));

  const avisar = () => {
    document.dispatchEvent(new CustomEvent('wishlist:cambio', { detail: { items: comoLista() } }));
  };

  // Quien llegue tarde al evento puede preguntar. Hace falta: este fichero se
  // carga desde el <head> y la página de favoritos desde su sección, así que
  // el primer aviso se dispara antes de que ella tenga puesto el oído.
  cfg.obtener = comoLista;
  cfg.identificado = identificado;
  window.divainWishlist = cfg;

  const pintarEn = (nodos) => {
    nodos.forEach((boton) => {
      boton.setAttribute('aria-pressed', guardados.has(boton.dataset.wishlistProduct) ? 'true' : 'false');
    });
  };

  const pintarTodo = () => pintarEn(Array.from(document.querySelectorAll(SEL)));

  // Sin sesión se abre la hoja nativa de Shopify, la misma del icono de
  // perfil. Si por lo que sea no estuviera disponible, se va al login a
  // página completa en vez de no hacer nada.
  const pedirSesion = () => {
    const cuenta = document.querySelector('[data-wishlist-sesion]');

    if (cuenta && typeof cuenta.showModal === 'function') {
      try {
        cuenta.showModal();
        return;
      } catch (e) {
        /* cae al login de página completa */
      }
    }

    const destino = window.location.pathname + window.location.search;
    window.location.href = '/account/login?return_url=' + encodeURIComponent(destino);
  };

  const llamar = async (cuerpo) => {
    const respuesta = await fetch(RUTA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    });
    const datos = await respuesta.json().catch(() => null);
    if (!respuesta.ok || !datos || datos.ok !== true) {
      const error = new Error((datos && datos.error) || 'error_' + respuesta.status);
      error.datos = datos;
      throw error;
    }
    return datos;
  };

  // La respuesta del proxy manda: trae la lista resultante y con ella se
  // repinta todo, no solo el corazón pulsado.
  const aplicar = (datos) => {
    guardados = aMapa(datos.items);
    pintarTodo();
    avisar();
  };

  const alternar = async (boton) => {
    const gid = boton.dataset.wishlistProduct;
    if (!gid) return;

    if (!identificado) {
      pedirSesion();
      return;
    }

    const estaba = guardados.has(gid);
    const handle = boton.dataset.wishlistHandle || '';

    // Optimista: el corazón responde al momento y se revierte si falla.
    if (estaba) guardados.delete(gid);
    else guardados.set(gid, handle);
    pintarTodo();
    avisar();

    boton.setAttribute('aria-busy', 'true');
    try {
      aplicar(await llamar({ action: 'toggle', product: gid }));
    } catch (e) {
      if (estaba) guardados.set(gid, handle);
      else guardados.delete(gid);
      pintarTodo();
      avisar();

      // La sesión puede haber caducado con la página abierta.
      if (e.message === 'not_logged_in') pedirSesion();
      boton.dispatchEvent(new CustomEvent('wishlist:error', { bubbles: true, detail: { error: e } }));
    } finally {
      boton.removeAttribute('aria-busy');
    }
  };

  // En captura: la tarjeta entera suele ser un enlace, y sin esto el clic en
  // el corazón navegaría al producto.
  document.addEventListener(
    'click',
    (evento) => {
      if (!(evento.target instanceof Element)) return;

      // El botón de la página de favoritos abre la misma hoja que el corazón.
      const entrar = evento.target.closest('[data-wishlist-entrar]');
      if (entrar) {
        evento.preventDefault();
        pedirSesion();
        return;
      }

      const boton = evento.target.closest(SEL);
      if (!boton) return;
      evento.preventDefault();
      evento.stopPropagation();
      alternar(boton);
    },
    true
  );

  // Las rejillas de colección se repintan por AJAX al filtrar, y esas tarjetas
  // nuevas llegan con el estado del servidor. Para quien ha iniciado sesión ya
  // viene bien; esto lo mantiene al día tras un alta o una baja.
  const observador = new MutationObserver((mutaciones) => {
    const nuevos = [];
    mutaciones.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.matches(SEL)) nuevos.push(n);
        nuevos.push(...n.querySelectorAll(SEL));
      });
    });
    if (nuevos.length) pintarEn(nuevos);
  });

  const arrancar = () => {
    pintarTodo();
    avisar();
    observador.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }
})();
